import { render } from "./OutlineAlerts.vue?vue&type=template&id=75147a5c&ts=true"
import script from "./OutlineAlerts.vue?vue&type=script&lang=ts"
export * from "./OutlineAlerts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__